import React, { Component } from "react";
import { Row, Col, Button } from "reactstrap";
import { Link } from "react-router-dom";
import { MDBDataTable } from "mdbreact";
import config from 'react-global-configuration';
import moment from 'moment'
import flat from 'flat'
import flatten from "flat";



class Users extends Component {
  constructor(props) {
    super(props);
    
    var authUser = JSON.parse(sessionStorage.getItem("authUser"))
    this.state = {
        users: [],
        authUser: authUser
    };

    this.getUsers()
  }

 

  handleRowClick = (id) => {
      console.log(id)
      this.props.history.push("/user/"+id)
  }

  getUsers = () => {
      console.log(this.state.user)
    fetch(config.get('apiUrl')+'users',{
        headers: {
            Authorization: 'Bearer '+ this.state.authUser.access_token
        }
    })
    .then(res=>res.json())
    .then((data)=> {
        console.log(data)
        data.users.map(user => {
            user.clickEvent = e => this.handleRowClick(user.uuid)
            user.type = user.type === 2 ? "Admin" : "Moderaator"
        })
        Object.keys(data.users).forEach(function(key) {
            data.users[key] = flatten(data.users[key])
        });
        console.log(data.auctions)
        this.setState({
            users: data.users
        })
        
    })
}

  render() {
    const data = {
      columns: [
        {
          label: "Eesnimi",
          field: "firstName",
          sort: "asc",
          width: 150
        },
        {
          label: "Perenimi",
          field: "surname",
          sort: "asc",
          width: 270
        },
        {
          label: "Tüüp",
          field: "type",
          sort: "asc",
          width: 200
        }
      ],
      rows: this.state.users
      
    };

    return (
      <React.Fragment>
        <div className="container-fluid">
          <Row className="align-items-center">
            <Col sm={6}>
              <div className="page-title-box">
                <h4 className="font-size-18">Kasutajad</h4>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to="/#">Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item active">Kasutajad</li>
                </ol>
              </div>
            </Col>

          </Row>

          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-body">
                <Link to="/user" className="waves-effect">
                <Button color="primary" className="mr-1">
                               Lisa kasutaja
                            </Button>
                </Link>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-body">

                  <MDBDataTable responsive bordered data={data} />
                </div>
              </div>
            </div>
          </div>

        </div>
      </React.Fragment>
    );
  }
}

export default Users;
